import { useState } from "react";

import OrderNoticeSelectModal from "./OANoticeSelect/OANoticeSelect";
import OrderNoticePreviewModal from "./OANoticePreview/OANoticePreview";

import { useGetDistributionListsForOrder } from "@/hooks/planning/order_application/useDistributionListsForOrder";

const OANotice = ({ code, onClose }) => {
	const [showSelect, setShowSelect] = useState(true);
	const [showPreview, setShowPreview] = useState(false);
	const [selectedLists, setSelectedLists] = useState([]);
	const [distributionListNames, setDistributionListNames] = useState({});

	const { data: distributionListsData = [] } = useGetDistributionListsForOrder(code);

	if (!code) {
		return null;
	}

	const handleSelectNext = (selectedListIds) => {
		const namesMap = distributionListsData
			.filter((distributionList) => selectedListIds.includes(distributionList.id))
			.map((distributionList) => distributionList.name)
			.join(", ");

		setSelectedLists(selectedListIds);
		setDistributionListNames(namesMap);
		setShowSelect(false);
		setShowPreview(true);
	};

	const handleBackToSelect = () => {
		setShowPreview(false);
		setShowSelect(true);
	};

	return (
		<>
			<OrderNoticeSelectModal show={showSelect} onHide={onClose} onNext={handleSelectNext} distributionListsData={distributionListsData} />

			<OrderNoticePreviewModal
				show={showPreview}
				onHide={onClose}
				onBack={handleBackToSelect}
				orderApplicationId={code}
				selectedLists={selectedLists}
				distributionListNames={distributionListNames}
			/>
		</>
	);
};

export default OANotice;
